var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredAngryFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C12.9853 21 15 18.9853 15 16.5C15 14.0147 12.9853 12 10.5 12C8.01472 12 6 14.0147 6 16.5C6 18.9853 8.01472 21 10.5 21Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21C23.9853 21 26 18.9853 26 16.5C26 14.0147 23.9853 12 21.5 12C19.0147 12 17 14.0147 17 16.5C17 18.9853 19.0147 21 21.5 21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2901 12.501C14.7037 12.5231 15.0212 12.8763 14.9991 13.2899C14.9771 13.7035 14.6239 14.0209 14.2103 13.9989C13.1931 13.9447 12.2216 13.6953 11.3935 13.1186C10.5582 12.537 9.93332 11.6671 9.53893 10.4878C9.40755 10.095 9.61949 9.67007 10.0123 9.53869C10.4051 9.40731 10.8301 9.61925 10.9615 10.0121C11.2718 10.9398 11.7237 11.5207 12.2507 11.8877C12.7848 12.2597 13.4609 12.4568 14.2901 12.501Z",
    fill: "#402A32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7103 12.501C17.2967 12.5231 16.9792 12.8763 17.0013 13.2899C17.0233 13.7035 17.3765 14.0209 17.7901 13.9989C18.8073 13.9447 19.7788 13.6953 20.6069 13.1186C21.4422 12.537 22.0671 11.6671 22.4615 10.4878C22.5929 10.095 22.3809 9.67007 21.9881 9.53869C21.5953 9.40731 21.1703 9.61925 21.0389 10.0121C20.7286 10.9398 20.2767 11.5207 19.7497 11.8877C19.2156 12.2597 18.5395 12.4568 17.7103 12.501Z",
    fill: "#402A32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 24C13.9956 24 13.0661 25.1042 12.8946 25.4472C12.6476 25.9412 12.047 26.1414 11.553 25.8944C11.059 25.6474 10.8588 25.0467 11.1058 24.5527C11.6009 23.5624 13.2048 22 16.0002 22C18.7956 22 20.3995 23.5624 20.8946 24.5527C21.1416 25.0467 20.9414 25.6474 20.4474 25.8944C19.9534 26.1414 19.3528 25.9412 19.1058 25.4472C18.9343 25.1042 18.0048 24 16.0002 24Z",
    fill: "#402A32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 17C14.0002 18.1045 13.1048 19 12.0002 19C10.8957 19 10.0002 18.1045 10.0002 17C10.0002 15.8954 10.8957 15 12.0002 15C13.1048 15 14.0002 15.8954 14.0002 17Z",
    fill: "#402A32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 17C22.0002 18.1045 21.1048 19 20.0002 19C18.8957 19 18.0002 18.1045 18.0002 17C18.0002 15.8954 18.8957 15 20.0002 15C21.1048 15 22.0002 15.8954 22.0002 17Z",
    fill: "#402A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredAngryFace);
export default __webpack_public_path__ + "static/media/coloredAngryFace.f7dbe8d6ffbb772db5d6b6e81b8c1d2c.svg";
export { ForwardRef as ReactComponent };